/* Web Push subscription helper */
import { api } from './api';

function urlBase64ToUint8Array(base64String) {
    const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
    const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
    const raw = window.atob(base64);
    const out = new Uint8Array(raw.length);
    for (let i = 0; i < raw.length; ++i) out[i] = raw.charCodeAt(i);
    return out;
}

export async function getPushSupport() {
    return 'serviceWorker' in navigator && 'PushManager' in window && 'Notification' in window;
}

export async function getPushStatus() {
    if (!(await getPushSupport())) return { supported: false, granted: false, subscribed: false };
    let subscribed = false;
    try {
        const reg = await navigator.serviceWorker.getRegistration();
        const sub = reg ? await reg.pushManager.getSubscription() : null;
        subscribed = !!sub;
    } catch {}
    return {
        supported: true,
        granted: Notification.permission === 'granted',
        denied: Notification.permission === 'denied',
        subscribed,
    };
}

export async function enablePush() {
    if (!(await getPushSupport())) throw new Error('Browseren understøtter ikke push-notifikationer');
    const cfg = await api.get('/push/config');
    if (!cfg.data?.configured || !cfg.data?.public_key) {
        throw new Error('Push er ikke konfigureret på serveren');
    }
    const permission = await Notification.requestPermission();
    if (permission !== 'granted') throw new Error('Tilladelse til notifikationer afvist');
    const reg = await navigator.serviceWorker.ready;
    let sub = await reg.pushManager.getSubscription();
    if (!sub) {
        sub = await reg.pushManager.subscribe({
            userVisibleOnly: true,
            applicationServerKey: urlBase64ToUint8Array(cfg.data.public_key),
        });
    }
    await api.post('/push/subscribe', { subscription: sub.toJSON() });
    return true;
}

export async function disablePush() {
    try {
        const reg = await navigator.serviceWorker.getRegistration();
        if (reg) {
            const sub = await reg.pushManager.getSubscription();
            if (sub) await sub.unsubscribe();
        }
    } catch (e) { console.error('[push] unsubscribe sw failed', e); }
    await api.post('/push/unsubscribe', {});
    return true;
}

export async function testPush() {
    const r = await api.post('/push/test', {});
    return r.data?.sent || 0;
}
